/**
 * @module env-capabilities
 * 
 * Handles adding classes to the html tag that correspond
 * to whether the environment has certain capabilities.
 * 
 * This was chosen over a tool like modernizr because we
 * believe we will only need very minimal environment detection.
 */

import { selectOne, addClass } from './utils/dom-utils';


const NO_TOUCH_CLASS_NAME = 'no-touch';

/**
 * Determines whether or not the current browser environment
 * supports touch events.
 * 
 * @return {Boolean}
 */
function hasTouchSupport() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

export default function addEnvClasses() {
  if (!hasTouchSupport()) {
    addClass(selectOne('html'), NO_TOUCH_CLASS_NAME);
  }
}
